/* ============================================================
   Hash-Based View Router
   ============================================================ */
import { DEFAULT_VIEW, VIEW_IDS } from "@/config/views";
class Router {
    listeners = [];
    constructor() {
        window.addEventListener("hashchange", () => this.notify());
    }
    get currentView() {
        const hash = window.location.hash.replace("#/", "").replace("#", "");
        if (VIEW_IDS.includes(hash))
            return hash;
        return DEFAULT_VIEW;
    }
    navigate(view) {
        window.location.hash = `#/${view}`;
    }
    onChange(cb) {
        this.listeners.push(cb);
    }
    notify() {
        const view = this.currentView;
        for (const cb of this.listeners)
            cb(view);
    }
}
export const router = new Router();
